import { isPlaceholderAddress, isMultipleStreetAddress } from './addressQuality';
import { WATCH_ZONE_PRESETS } from './constants';
import { supabase } from '../supabaseClient';
import { dedupeDAsForDisplay, displayDALocation, isParcelOnlyAddress, sortDAsForFeed } from './daDisplay';
import {
  noteSupabaseFailure,
  noteSupabaseSuccess,
  shouldShortCircuitSupabase,
  supabaseCircuitError,
} from './supabaseCircuitBreaker';

export const sStyle = s => ({"Submitted":{bg:"rgba(160,170,190,0.15)",c:"#8090a8"},"Open":{bg:"rgba(160,170,190,0.15)",c:"#8090a8"},"In Progress":{bg:"rgba(160,170,190,0.15)",c:"#8090a8"},"Under Assessment":{bg:"rgba(230,180,60,0.12)",c:"#c49520"},"On Exhibition":{bg:"rgba(120,160,230,0.12)",c:"#5580cc"},"Approved":{bg:"rgba(80,180,120,0.12)",c:"#2a9d5a"},"Determined":{bg:"rgba(80,180,120,0.12)",c:"#2a9d5a"},"Deferred Commencement":{bg:"rgba(80,180,120,0.12)",c:"#2a9d5a"},"Refused":{bg:"rgba(220,80,80,0.12)",c:"#c04040"},"Rejected":{bg:"rgba(220,80,80,0.12)",c:"#c04040"},"Withdrawn":{bg:"rgba(160,170,190,0.1)",c:"#607088"},"Cancelled":{bg:"rgba(160,170,190,0.1)",c:"#607088"}}[s]||{bg:"rgba(160,170,190,0.15)",c:"#8090a8"});

export const catTag = d => { const l=(d||"").toLowerCase(); if(l.includes("subdivision"))return{l:"SUBDIVISION",c:"#5580cc"}; if(l.includes("commercial")||l.includes("retail")||l.includes("food and drink"))return{l:"COMMERCIAL",c:"#2a9d5a"}; if(l.includes("industrial"))return{l:"INDUSTRIAL",c:"#c07040"}; if(l.includes("mixed use"))return{l:"MIXED USE",c:"#9060c0"}; if(l.includes("demolition")&&(l.includes("dwelling")||l.includes("apartment")))return{l:"MAJOR",c:"#d4a84a"}; return{l:"RESIDENTIAL",c:"#8090a8"}; };

export const cShort = n => (n||"").replace(" Council","").replace(" Shire","").replace(" City","");

export const dAgo = d => { if(!d)return""; const x=Math.floor((new Date()-new Date(d))/864e5); return x===0?"Today":x===1?"Yesterday":`${x}d ago`; };

export const sAddr = a => displayDALocation({ address: a }).replace(/\s*(?:NSW\s*\d{4}|\d{4}\s*NSW|NSW)\s*$/i,"");

export const hasValidCoords = a => {
  if (!a || isPlaceholderAddress(a.address) || isMultipleStreetAddress(a.address) || a.latitude === null || a.latitude === undefined || a.latitude === '' || a.longitude === null || a.longitude === undefined || a.longitude === '') return false;
  return Number.isFinite(Number(a.latitude)) && Number.isFinite(Number(a.longitude));
};

export const haversine = (lat1,lng1,lat2,lng2) => { const R=6371e3,p=Math.PI/180,a=Math.sin((lat2-lat1)*p/2)**2+Math.cos(lat1*p)*Math.cos(lat2*p)*Math.sin((lng2-lng1)*p/2)**2; return 2*R*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)); };

export function findClosestPreset(latLng) {
  let closest=null, minDist=Infinity;
  WATCH_ZONE_PRESETS.forEach(p => {
    const d=Math.sqrt(Math.pow(latLng.lat()-p.lat,2)+Math.pow(latLng.lng()-p.lng,2));
    if(d<minDist){minDist=d;closest=p;}
  });
  return { preset: closest, distKm: minDist*111 };
}

// Map DB category values to display badge
export const catFromCategory = c => {
  const k = (c || '').toLowerCase();
  if (k.includes('subdivision'))             return { l: 'SUBDIVISION',  c: '#5580cc' };
  if (k.includes('complying development'))   return { l: 'COMPLYING DEV', c: '#2a9d5a' };
  if (k.includes('construction certificate'))return { l: 'CONSTRUCTION',  c: '#c07040' };
  if (k.includes('occupation certificate'))  return { l: 'OCC CERT',      c: '#9060c0' };
  if (k.includes('modification'))            return { l: 'MODIFICATION',  c: '#d4a84a' };
  if (k.includes('development application')) return { l: 'DA',            c: '#8090a8' };
  return { l: 'OTHER', c: '#8090a8' };
};

export const DA_BROWSE_SELECT = [
  'id',
  'da_number',
  'address',
  'suburb',
  'description',
  'estimated_cost',
  'cost_of_development',
  'status',
  'category',
  'council',
  'lodged_date',
  'latitude',
  'longitude',
  'application_type',
  'development_type',
  'construction_type',
  'proposal_type_ai',
  'proposal_type_ai_confidence',
  'proposal_type_ai_evidence',
  'number_of_new_dwellings',
  'dwelling_count',
  'number_of_storeys',
  'storeys',
  'exhibition_start',
  'exhibition_end',
  'exhibition_start_date',
  'exhibition_end_date',
  'source',
  'source_id',
  'source_url',
  'data_source',
  'council_application_number',
  'planning_portal_app_number',
  'previous_status',
  'status_changed_at',
  'created_at',
  'updated_at',
  'last_enriched_at',
].join(', ');

export const DA_BROWSE_DAYS = 365;
export const DA_BROWSE_LIMIT = 5000;
export const DA_BROWSE_PAGE_SIZE = 1000;
export const DA_BROWSE_PAGE_TIMEOUT_MS = 6500;
export const DA_BROWSE_EARLY_PORTAL_TIMEOUT_MS = 6500;

export const DA_DETAIL_SELECT = [
  DA_BROWSE_SELECT,
  'description',
  'source_url',
  'related_applications',
  'related_certificates',
  'cost_of_development',
  'construction_type',
  'number_of_new_dwellings',
  'dwelling_count',
  'number_of_storeys',
  'storeys',
  'exhibition_start_date',
  'exhibition_start',
  'exhibition_end_date',
  'exhibition_end',
  'determined_date',
  'determination_date',
  'development_type',
  'determination_authority',
  'lot_id_string',
  'data_source',
].join(', ');

export const EMPTY_PIPELINE_STATS = {
  total_das: 0,
  total_pipeline_value: 0,
  avg_cost: 0,
  period_days: 30,
  status_breakdown: {},
  largest_cost: 0,
  dwellings: 0,
  trend: null,
  total: 0,
  count: 0,
  largest: 0,
  avg: 0,
};

function normalizePipelineStats(data, fallbackDays) {
  const total = Number(data?.total_pipeline_value || 0);
  const count = Number(data?.total_das || 0);
  const avg = Number(data?.avg_cost || 0);
  const largest = Number(data?.largest_cost || 0);
  return {
    total_das: count,
    total_pipeline_value: total,
    avg_cost: avg,
    period_days: Number(data?.period_days ?? fallbackDays ?? 30),
    status_breakdown: data?.status_breakdown || {},
    largest_cost: largest,
    dwellings: Number(data?.dwellings || 0),
    trend: data?.trend ?? null,
    // Compatibility fields used by the existing Dashboard component.
    total,
    count,
    largest,
    avg,
  };
}

export async function fetchPipelineStats(councils, days = 30, categories = null) {
  const safeDays = Number.isFinite(Number(days)) ? Number(days) : 30;
  if (shouldShortCircuitSupabase()) {
    const error = supabaseCircuitError();
    return { ...EMPTY_PIPELINE_STATS, period_days: safeDays, load_error: error.message };
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 4500);
  let data;
  let error;

  try {
    ({ data, error } = await supabase.rpc('get_pipeline_stats_cached', {
      p_councils: councils?.length ? councils : null,
      p_days: safeDays,
      p_categories: categories?.length ? categories : null,
    }).abortSignal(controller.signal));
  } catch (err) {
    error = err?.name === 'AbortError'
      ? { message: 'Pipeline stats request timed out' }
      : err;
  } finally {
    clearTimeout(timeoutId);
  }

  if (error) {
    noteSupabaseFailure(error);
    console.error('Pipeline stats error:', error.message || error);
    return { ...EMPTY_PIPELINE_STATS, period_days: safeDays, load_error: error.message || 'Pipeline stats unavailable' };
  }

  noteSupabaseSuccess();
  const stats = normalizePipelineStats(data, safeDays);
  if (data?.load_error) stats.load_error = data.load_error;
  if (data?.cached_at || data?.refreshed_at) stats.cached_at = data.cached_at || data.refreshed_at;
  if (data?.stale !== undefined) stats.stale = Boolean(data.stale);
  if (data?.cache_miss !== undefined) stats.cache_miss = Boolean(data.cache_miss);
  return stats;
}

export async function fetchApps() {
  if (shouldShortCircuitSupabase()) {
    throw supabaseCircuitError();
  }

  // Load the last 365 days as a bounded, paginated dashboard feed. Search uses
  // RPCs for full historical lookup; the dashboard should still represent the
  // current working year instead of silently truncating at Supabase's 1k cap.
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - DA_BROWSE_DAYS);
  const portalCutoff = new Date();
  portalCutoff.setDate(portalCutoff.getDate() - 1);
  const buildBrowseQuery = () => supabase
    .from('da_browse_view')
    .select(DA_BROWSE_SELECT)
    .gte('lodged_date', cutoff.toISOString().split('T')[0])
    .order('lodged_date', { ascending: false });

  const buildEarlyPortalQuery = () => supabase
    .from('da_browse_view')
    .select(DA_BROWSE_SELECT)
    .is('lodged_date', null)
    .eq('source', 'planning_portal')
    .gte('created_at', portalCutoff.toISOString())
    .order('created_at', { ascending: false });

  let browseResult;
  let earlyPortalResult;

  try {
    [browseResult, earlyPortalResult] = await Promise.all([
      fetchPagedQuery(buildBrowseQuery, {
        limit: DA_BROWSE_LIMIT,
        pageSize: DA_BROWSE_PAGE_SIZE,
      }),
      runDashboardQueryWithTimeout(
        signal => buildEarlyPortalQuery().range(0, 39).abortSignal(signal),
        DA_BROWSE_EARLY_PORTAL_TIMEOUT_MS,
        'DA early portal request timed out'
      ),
    ]);
  } catch (err) {
    const error = err?.name === 'AbortError'
      ? dashboardFeedTimeout('DA browse request timed out')
      : err;
    if (!isDashboardFeedTimeout(error)) noteSupabaseFailure(error);
    console.error('fetchApps:', error.message || error);
    throw error;
  }

  if (browseResult.error) {
    if (!isDashboardFeedTimeout(browseResult.error)) noteSupabaseFailure(browseResult.error);
    console.error('fetchApps:', browseResult.error.message);
    throw browseResult.error;
  }
  if (earlyPortalResult.error) {
    if (!isDashboardFeedTimeout(earlyPortalResult.error)) noteSupabaseFailure(earlyPortalResult.error);
    console.error('fetchApps early portal:', earlyPortalResult.error.message);
    throw earlyPortalResult.error;
  }

  const byId = new Map();
  for (const row of [...(browseResult.data || []), ...(earlyPortalResult.data || [])]) {
    if (isParcelOnlyAddress(row?.address)) continue;
    if (row?.id) byId.set(row.id, row);
  }

  noteSupabaseSuccess();
  return sortDAsForFeed(dedupeDAsForDisplay([...byId.values()]));
}

function dashboardFeedTimeout(message) {
  const error = new Error(message);
  error.name = 'DashboardFeedTimeoutError';
  error.code = 'DASHBOARD_FEED_TIMEOUT';
  return error;
}

export function isDashboardFeedTimeout(error) {
  return error?.code === 'DASHBOARD_FEED_TIMEOUT' || error?.name === 'DashboardFeedTimeoutError';
}

async function runDashboardQueryWithTimeout(runQuery, timeoutMs, timeoutMessage) {
  const controller = new AbortController();
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      // PostgREST normally RESOLVES aborts as { error, status: 0 }, rather
      // than throwing. Settle our deadline first, then cancel the transport.
      reject(dashboardFeedTimeout(timeoutMessage));
      controller.abort();
    }, timeoutMs);
  });
  try {
    const result = await Promise.race([
      Promise.resolve().then(() => runQuery(controller.signal)), timeout,
    ]);
    if (controller.signal.aborted) throw dashboardFeedTimeout(timeoutMessage);
    return result;
  } catch (err) {
    if (controller.signal.aborted || err?.name === 'AbortError') {
      throw dashboardFeedTimeout(timeoutMessage);
    }
    throw err;
  } finally {
    clearTimeout(timeoutId);
  }
}

async function fetchPagedQuery(buildQuery, { limit, pageSize }) {
  const rows = [];
  const safeLimit = Math.max(0, Number(limit) || 0);
  const safePageSize = Math.max(1, Number(pageSize) || safeLimit || 1);

  for (let offset = 0; offset < safeLimit; offset += safePageSize) {
    const to = Math.min(offset + safePageSize, safeLimit) - 1;
    const result = await runDashboardQueryWithTimeout(
      signal => buildQuery().range(offset, to).abortSignal(signal),
      DA_BROWSE_PAGE_TIMEOUT_MS,
      'DA browse page request timed out'
    );
    if (result.error) return { data: rows, error: result.error };
    const pageRows = result.data || [];
    rows.push(...pageRows);
    if (pageRows.length < to - offset + 1) break;
  }

  return { data: rows, error: null };
}

export async function fetchDADetailRow(daId) {
  if (!daId) return null;
  const { data, error } = await supabase
    .from('da_browse_view')
    .select(DA_DETAIL_SELECT)
    .eq('id', daId)
    .single();
  if (error) {
    console.error('fetchDADetailRow:', error.message);
    return null;
  }
  return data;
}
